module.exports = __webpack_public_path__ + "static/img/2.b1dface.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/scheme/2.jpg
// module id = Hsnp
// module chunks = 1